import { render, staticRenderFns } from "./community-roles.vue?vue&type=template&id=8a0f44c6&scoped=true"
import script from "./community-roles.vue?vue&type=script&lang=js"
export * from "./community-roles.vue?vue&type=script&lang=js"
import style0 from "./community-roles.vue?vue&type=style&index=0&id=8a0f44c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0f44c6",
  null
  
)

export default component.exports